import { jsx as _jsx } from "react/jsx-runtime";
import { cloneArr, deepClone, removeFromArrayByIndex, sortArray } from '@nu-art/ts-common';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/components/Layouts/Layouts';
import { SimpleListAdapter } from '@nu-art/thunderstorm-frontend/components/adapter/Adapter';
import Big from 'big.js';
import { QRangeInput, resolveRangeForPrint } from '@app/hcs-frontend';
import { ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, TS_Table } from '@nu-art/thunderstorm-frontend/index';
export class Component_PrognosisEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.editingItem = state.editingItem || {};
        state._prognosis = state._prognosis || deepClone(nextProps.value || nextProps.defaultValue || []);
        if (!state._prognosis.includes(state.editingItem) && !nextProps.disableEdit)
            state._prognosis.push(state.editingItem);
        state.disableEdit = nextProps.disableEdit;
        return state;
    }
    isValidYears = (val) => {
        if (!val || val[0] > val[1] || val[0] < 0)
            return;
        return val;
    };
    isValidSurvivalChance = (val) => {
        if (!val)
            return;
        val[0] = Math.max(val[0], 0);
        val[0] = Math.min(val[0], 100);
        val[1] = Math.min(val[1], 100);
        val[1] = Math.max(val[1], val[0]);
        return [val[0] / 100, val[1] / 100];
    };
    deletePrognosisItem(index) {
        removeFromArrayByIndex(this.state._prognosis, index);
        this.props.onChange(cloneArr(this.state._prognosis.filter(item => this.isValidSurvivalChance(item.survivalChance) && this.isValidYears(item.years))));
        this.forceUpdate();
    }
    savePrognosis = (prognosisItem) => {
        const validPrognosisItems = this.state._prognosis.filter(item => this.isValidSurvivalChance(item.survivalChance) && this.isValidYears(item.years));
        this.props.onChange(sortArray(cloneArr(validPrognosisItems), item => item.years[0]));
        if (this.state._prognosis.length === validPrognosisItems.length)
            this.reDeriveState({ editingItem: undefined });
    };
    renderPrognosisHeader = (header) => {
        switch (header) {
            case 'years':
                return 'Years';
            case 'survivalChance':
                return 'Survival Chance %';
        }
        return _jsx("div", { children: header });
    };
    render() {
        const prognosisHeaders = ['years', 'survivalChance'];
        return _jsx(LL_V_L, { className: 'match_width', children: _jsx(TS_Table, { header: [...prognosisHeaders.map((header, i) => ({ header: header, widthPx: 200 }))], headerRenderer: (header) => this.renderPrognosisHeader(header), rows: this.state._prognosis, cellRenderer: (prop, item) => {
                    switch (prop) {
                        case 'years':
                            return this.renderYearsCell(item);
                        case 'survivalChance':
                            return this.renderSurvivalRateCell(item);
                    }
                }, tr: (row, index) => ({
                    onContextMenu: e => {
                        if (this.state.disableEdit || row === this.state.editingItem)
                            return;
                        const menuItems = [
                            { label: 'Remove', onClick: () => this.deletePrognosisItem(index) },
                        ];
                        const rightClickMenu = {
                            id: 'prognosis-right-click-menu',
                            adapter: SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label })),
                            originPos: { y: e.clientY, x: e.clientX, },
                            modalPos: { x: 0, y: 1 },
                            onNodeClicked: (path, item) => {
                                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                                item.onClick?.();
                            }
                        };
                        ModuleFE_MouseInteractivity.showMenu(rightClickMenu);
                    }
                }) }) });
    }
    renderYearsCell = (prognosisItem) => {
        if (this.state.disableEdit)
            return _jsx("div", { children: resolveRangeForPrint(prognosisItem.years) });
        return _jsx(QRangeInput, { placeholder: 'Years', value: prognosisItem.years, onValueBlur: val => {
                const years = this.isValidYears(val);
                if (years)
                    prognosisItem.years = years;
                else
                    delete prognosisItem.years;
                // if (!this.isValidSurvivalChance(prognosisItem.survivalChance))
                // 	return;
                this.savePrognosis(prognosisItem);
            } });
    };
    renderSurvivalRateCell = (prognosisItem) => {
        const prognosisValue = prognosisItem.survivalChance ? [new Big(prognosisItem.survivalChance[0]).times(100).toNumber(), new Big(prognosisItem.survivalChance[1]).times(100).toNumber()] : undefined;
        if (this.state.disableEdit)
            return _jsx("div", { children: resolveRangeForPrint(prognosisValue) });
        return _jsx(QRangeInput, { placeholder: '%', value: prognosisValue, onValueBlur: val => {
                const survivalChance = this.isValidSurvivalChance(val);
                if (survivalChance)
                    prognosisItem.survivalChance = survivalChance;
                else
                    delete prognosisItem.survivalChance;
                this.logInfo(`Survival Chance: ${prognosisItem.survivalChance}`);
                this.savePrognosis(prognosisItem);
            } });
    };
}
//# sourceMappingURL=Component_PrognosisEditor.js.map